<template>
<ion-page>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-toggle auto-hide="false">
          <img src="../assets/svg/logo-toolbar.svg">
          <!-- <ion-button>
            <ion-icon slot="icon-only" name="menu"></ion-icon>
          </ion-button> -->
        </ion-menu-toggle>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button class="btn-back" @click="backItem">Back to index</ion-button>
        <ion-button class="btn-back" @click="backIndex">Back</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-content padding>
    <bg :opaque="1"></bg>
    <ion-grid>
      <form @submit="save">
        <ion-row class="row-boxed mt-20">
          <ion-col size="12">
            <div class="toolbar-add">
              <div class="nowrap">{{ index.title }}</div>
            </div>
            <div class="progress-wrapper">
              <span>Progress:</span>
              <range v-if="indexCopy.hasOwnProperty('progress')" ref="range" :min="0" :max="100" :step="25" v-model="indexCopy.progress"></range>
            </div>

            <ion-row class="m-neg">
              <ion-col size="12" size-md="8">
                <div class="item-block">
                  <div class="item-block-header">
                    <div>ITEM</div>
                  </div>
                  <div class="item-block-content item-block-content-full">
                    <textarea :disabled="$store.state.user_role == 'client' ? true : false" class="item-textarea" v-model="indexCopy.name" v-on:blur="capitalize"></textarea>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12" size-md="4">
                <div class="item-block">
                  <div class="item-block-header">
                    <div>PHOTOS</div>
                    <file-upload
                        v-if="$store.state.user_role != 'client'"
                        input-id="uploadImg"
                        class="upload-btn"
                        :post-action="apiUrl + '/api/v1/upload'"
                        :data="{api_token: $store.state.api_token}"
                        :multiple="true"
                        :drop="true"
                        :extensions="['jpg', 'jpeg', 'gif', 'png', 'webp']"
                        :drop-directory="false"
                        v-model="indexImg"
                        @input-file="inputYatchImg"
                        ref="uploadImg">
                      <img src="../assets/svg/icon-add.svg">
                    </file-upload>
                  </div>
                  <div class="item-block-content item-block-content-full">
                    <div class="img-wrapper">
                      <div v-for="(ic,i) in indexCopy.images" :key="'im'+i" class="index-img">
                        <span v-if="$store.state.user_role != 'client'" @click="() => removeItemImage(i)">-</span>
                        <img :src="ic">
                      </div>
                    </div>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>
        <ion-row class="row-notes row-boxed" v-for="(n,i) in indexCopy.notes" :key="'notes-'+i">
          <ion-col size="12">
            <ion-row class="m-neg">
              <ion-col size="12" size-md="7">
                <div class="item-block">
                  <div class="item-block-header">
                    <div>NOTE</div>
                  </div>
                  <div class="item-block-content item-block-content-full">
                    <textarea :disabled="$store.state.user_role == 'client' ? true : false" class="item-textarea item-textarea-small" v-model="n.desc"></textarea>
                  </div>
                </div>
              </ion-col>
              <ion-col size="12" size-md="4">
                <div class="item-block">
                  <div class="item-block-header item-block-header-note">
                    <div>PHOTOS</div>
                    <span @click="() => setActiveNote(i)">
                            <file-upload
                                v-if="$store.state.user_role != 'client'"
                                :input-id="'uploadImgNote-'+i"
                                class="upload-btn"
                                :post-action="apiUrl + '/api/v1/upload'"
                                :data="{api_token: $store.state.api_token, ret: i}"
                                :multiple="true"
                                :drop="true"
                                :extensions="['jpg', 'jpeg', 'gif', 'png', 'webp']"
                                :drop-directory="false"
                                v-model="indexImgNote[i]"
                                @input-file="inputImgNote"
                                :ref="'uploadImgNote-'+i"
                            >
                              <img src="../assets/svg/icon-add.svg">
                            </file-upload>
                          </span>
                  </div>
                  <div class="item-block-content item-block-content-full">
                    <div class="img-wrapper">
                      <div v-for="(ic,j) in n.images" :key="'im'+j" class="index-img">
                        <span v-if="$store.state.user_role != 'client'" @click="() =>  removeNoteImage(i, j)">-</span>
                        <img :src="ic">
                      </div>
                    </div>
                  </div>
                </div>
              </ion-col>
              <ion-col size-md="1">
                <div class="item-block-btn">
                  <div class="note-btn" @click="deleteNote(i)">
                    <img src="../assets/svg/icon-delete.svg">
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="row-boxed" v-if="$store.state.user_role != 'client'">
          <ion-col size="6" class="text-left">
            <div class="note-btn" @click="addNote"><img src="../assets/svg/icon-add.svg"> Add note</div>
          </ion-col>
        </ion-row>

        <ion-row class="row-boxed" v-if="$store.state.user_role != 'client'">
          <ion-col size="12" class="text-right">
            <ion-button type="submit">SAVE</ion-button>
          </ion-col>
        </ion-row>
        <!-- Permette l'invio del form con tasto enter -->
        <input type="submit" class="hidden">
      </form>
    </ion-grid>
  </ion-content>
</ion-page>
</template>

<script>
import axios from "axios";
import FileUpload from 'vue-upload-component'
import 'vue-range-component/dist/vue-range-slider.css'
import Range from 'vue-range-component'
import Vue from 'vue'

export default {
  name: "CompileWorklistIndex",
  components: {
    FileUpload,
    Range
  },
  data() {
    return {
      index: {},
      indexCopy: {},
      indexArray: this.$route.params.index,
      indexImg: [],
      indexImgNote: [],
      activeNote: '',
      loader: true
    }
  },
  methods: {
    addNote: function() {
      let note = {
        desc: '',
        images: []
      }
      this.indexCopy.notes.push(note)
    },
    removeItemImage: function(index) {
      this.indexCopy.images.splice(index, 1);
    },
    deleteNote(i) {
      console.log(i)
      this.indexCopy.notes.splice(i, 1);
    },
    removeNoteImage: function(i, j) {
      this.indexCopy.notes[i].images.splice(j, 1);

      // this.indexCopy.notes[this.activeNote].images.splice(i, 1);
    },
    async inputImgNote(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.loader = true;
        }
        if (newFile.error && !oldFile.error) {
          if (newFile.error && newFile.error == 'extension') {
            const toast = await this.$ionic.toastController.create({
              message: 'File not supported',
              color: 'danger',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
        }
        if (newFile.success && !oldFile.success) {
          this.loader = false;
          this.indexCopy.notes[this.activeNote].images.push(newFile.response.file)
          const toast = await this.$ionic.toastController.create({
            message: 'Image added succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
      }
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs['uploadImgNote-'+this.activeNote][0].active) {
          this.$refs['uploadImgNote-'+this.activeNote][0].active = true
        }
      }
    },
    setActiveNote: function(index) {
      this.activeNote = index
    },
    capitalize: function () {
      this.indexCopy.name = this.indexCopy.name.charAt(0).toUpperCase() + this.indexCopy.name.slice(1);
    },
    backItem: async function(){
      await this.save(null)
      this.$router.push('/worklist/report/details/' + this.index.report_id);
    },
    backIndex: async function(){
      await this.save(null)
      this.$router.push({ name: 'compile-worklist', params: { id: this.$route.params.id } })
    },
    save: async function(ev) {
      if(ev) {
        ev.preventDefault();
      }
      this.loader = true
      this.index.value[this.indexArray] = this.indexCopy
      await axios.post(this.apiUrl + '/api/v1/save-worklist-index', { api_token: this.$store.state.api_token, index: this.index })
          .then(async () => {
            const toast = await this.$ionic.toastController.create({
              message: 'Item saved succesfully',
              color: 'success',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
            this.loader = false;
          })
    },
    async inputYatchImg(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.progress !== oldFile.progress) {
          this.loader = true;
        }
        if (newFile.error && !oldFile.error) {
          if (newFile.error && newFile.error == 'extension') {
            const toast = await this.$ionic.toastController.create({
              message: 'File not supported',
              color: 'danger',
              position: 'bottom',
              duration: 2000
            })
            await toast.present();
          }
        }
        if (newFile.success && !oldFile.success) {
          this.loader = false;
          this.indexCopy.images.push(newFile.response.file)
          const toast = await this.$ionic.toastController.create({
            message: 'Image added succesfully',
            color: 'success',
            position: 'bottom',
            duration: 2000
          })
          await toast.present();
        }
      }

      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.uploadImg.active) {
          this.$refs.uploadImg.active = true
        }
      }
    },
  },
  created() {
    Range.methods.handleKeyup = ()=> console.log;
    Range.methods.handleKeydown = ()=> console.log;
  },
  mounted: function() {
    // BUG SU SCROLL TOP CHE VIENE FATTO IN AUTOMATICO
    // setInterval(() => {
    //   document.getElementsByClassName('ion-page')[1].scrollTop = 0
    // }, 100)

    axios.post(this.apiUrl + '/api/v1/get-worklist-index', { api_token: this.$store.state.api_token, id: this.$route.params.id })
        .then((response) => {
          let res = response.data
          if(res.data) {
            this.index = res.data
            Vue.set(this, 'indexCopy', JSON.parse(JSON.stringify(this.index.value[this.indexArray])))
          }
          this.loader = false;
        })
  }
}
</script>

<style scoped>
.index-img {
  position: relative;
  border: 1px solid;
  font-size: 0;
  margin-bottom: 25px;
}

.index-img span {
  position: absolute;
  font-size: 16px;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
  background-color: var(--ion-color-primary);
  border-radius: 4px;
  color: #fff;
  text-align: center;
  cursor: pointer;
}

.note-btn {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;
}

.note-btn img {
  height: 25px;
  margin-right: 10px;
}

.item-block-btn {
  border-radius: 4px;
  overflow: hidden;
  margin-top: 15px;
}

progress {
  width: 100%;
  height: 30px;
}

</style>